import React, { useMemo } from 'react'

import { PlusOutlined } from '@ant-design/icons'
import { Button } from 'antd'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import { useOperatorData } from '@contexts/operator/OperatorDataContext'
import { useIsStandard } from '@contexts/operator/PlanContext'
import InventoryMonitorsList from '@shared/inventory_monitors/InventoryMonitorsList'
import ListPageHeader from '@shared/ListPageHeader'

import { inventoryMonitorService } from '@services/operator/inventoryMonitorService'
import { inventoryTypeService } from '@services/operator/inventoryTypeService'

export default function OperatorInventoryMonitorsList() {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const { merchants } = useOperatorData()
  const isStandard = useIsStandard()

  const merchantOptions = useMemo(() => {
    return merchants.map(merchant => ({
      label: merchant.name,
      value: merchant.id
    }))
  }, [merchants])

  return (
    <div>
      <ListPageHeader
        items={['stocks', 'stocks.trackers']}
        actions={
          <Button type="primary" icon={<PlusOutlined />} onClick={() => navigate('/inventory_monitors/new')}>
            {t('common.button.new')}
          </Button>
        }
      />
      <InventoryMonitorsList
        service={inventoryMonitorService}
        inventoryTypeService={inventoryTypeService}
        role="operator"
        merchantOptions={merchantOptions}
        hideMerchantUI={isStandard}
      />
    </div>
  )
}
